  export enum QuoteActionTypes {
    GET_QUOTES = 'GET_QUOTES',
    SEND_EMAIL = 'SEND_EMAIL',
    PROCEED_REVIEW = 'PROCEED_REVIEW',
    PROCEED_BUY = 'PROCEED_BUY',
    GET_VAT = 'GET_VAT',
  }
  